import React from "react";
import { useTranslation } from 'react-i18next';
import ErrorMessage from "../errorMessage";

const NotFound = (props) => {
    const t = useTranslation()[0];
    const availableTechnicians = props.availableTechnicians;

    if (availableTechnicians && !availableTechnicians.fetchError) {
        return null;
    }

    if (availableTechnicians && availableTechnicians.fetchError) {
        return (
            <div>
                <div className="techniciansNotAvailableMessage">
                    <ErrorMessage error={availableTechnicians.error} />
                </div>
            </div>
        );
    }

    return (
        <div>
            <div className="techniciansNotAvailableMessage">
                <h1>{t("availableTechnician.noTime")}</h1>
            </div>
        </div>

        ); 
};
export default NotFound;